import Text from "common/Typography/Text";
import React, { useLayoutEffect, useState } from "react";
import SellExistingCoinsOptions from "features/trades/CancelTrade/SellExistingCoinsOptions";
import { useSymbolsMetadata } from "@shared/utils/hooks/misc.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface CancelTradeModalContentProps {
  showCloseOptions?: boolean;
  sellCoins: boolean;
  setSellCoins: (sellCoins: boolean) => void;
  isSymbolInactive?: boolean;
}

const CancelTradeModalContent = ({
  showCloseOptions,
  setSellCoins,
  sellCoins,
  isSymbolInactive,
}: CancelTradeModalContentProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADES);
  return showCloseOptions ? (
    <>
      <Text>{t("cancel_trade.existing_coins_question")}</Text>
      <SellExistingCoinsOptions
        sellCoins={sellCoins}
        setSellCoins={setSellCoins}
        isSymbolInactive={isSymbolInactive}
      />
    </>
  ) : (
    <Text>{t("cancel_trade.confirm_close")}</Text>
  );
};

export const useCancelTradeModalContent = (
  showCloseOptions?: boolean,
  symbol?: string,
  accountId?: number
) => {
  const { isSymbolActiveInAccount } = useSymbolsMetadata();
  const isSymbolInactive =
    !!symbol && !!accountId && !isSymbolActiveInAccount(symbol, accountId);
  const [sellCoins, setSellCoins] = useState(!isSymbolInactive);

  useLayoutEffect(() => {
    setSellCoins(!isSymbolInactive);
  }, [isSymbolInactive]);

  return {
    cancelTradeModalContent: (
      <CancelTradeModalContent
        showCloseOptions={showCloseOptions}
        sellCoins={sellCoins}
        setSellCoins={setSellCoins}
        isSymbolInactive={isSymbolInactive}
      />
    ),
    sellCoins,
    setSellCoins,
  };
};
